export interface IAdminSettings {
    date_format: string;
    time_format: string;
}
